<template>
  <vue-modal id="usesInfoModal"
             classes="vue-modal-container"
             height="auto"
             name="uses-info-modal"
             scrollable
             width="80%">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('uses-info-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content user-info-modal-content">
      <h3>{{ trans.subHeader }}</h3>
      <ul>
        <li>{{ trans.p_1_1 }}</li>
        <li>{{ trans.p_1_2 }}</li>
        <li>{{ trans.p_1_3 }}</li>
      </ul>
      <div>
        <img v-if="IS_CORDOVA_APP"
             :src="trans.img_1_1"/>
        <img v-else
             :src="`/${trans.img_1_1}`"/>
      </div>
      <h3>{{ trans.subHeader2 }}</h3>
      <ul>
        <li>{{ trans.p_2_1 }}</li>
        <li>{{ trans.p_2_2 }}</li>
        <li>{{ trans.p_2_3 }}</li>
      </ul>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_2_1"/>
      <img v-else
           :src="`/${trans.img_2_1}`"/>
      <h3>{{ trans.subHeader3 }}</h3>
      <p>{{ trans.p_3_1 }}</p>
      <h3>{{ trans.subHeader4 }}</h3>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_4_1"/>
      <img v-else
           :src="`/${trans.img_4_1}`"/>
      <h5>{{ trans.subHeader5 }}</h5>
      <p>{{ trans.p_5_1 }}</p>
      <h5>{{ trans.subHeader6 }}</h5>
      <p>{{ trans.p_6_1 }}</p>
      <div v-html="trans.content"></div>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_5_1"/>
      <img v-else
           :src="`/${trans.img_5_1}`"/>
      <div v-html="trans.content1"></div>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_6_1"/>
      <img v-else
           :src="`/${trans.img_6_1}`"/>
      <h5>{{ trans.subHeader8 }}</h5>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_8_1"/>
      <img v-else
           :src="`/${trans.img_8_1}`"/>
      <p>{{ trans.p_8_1 }}</p>
      <h5>{{ trans.subHeader9 }}</h5>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_9_1"/>
      <img v-else
           :src="`/${trans.img_9_1}`"/>
      <div v-html="trans.content3"></div>
      <img v-if="IS_CORDOVA_APP"
           :src="trans.img_10_1"/>
      <img v-else
           :src="`/${trans.img_10_1}`"/>
      <div v-html="trans.content4"></div>
    </div>
  </vue-modal>
</template>

<script>
import config from '@/config'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
    }
  },
  computed: {
    ...mapState({
      trans: state => state.trans.userInfoModal,
    }),
  },
}
</script>

<style scoped>
.user-info-modal-content img {
  max-height: 300px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
